import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "./HomepagePartnersNew.scss";
import { PartnersNewComponent_Plain } from "../../types/components/homepage/PartnersNewComponent";
import { getStrapiMedia } from "../../utils/utils";

interface HomepagePartnersNewProps {
  data?: PartnersNewComponent_Plain;
}

const HomepagePartnersNew: React.FC<HomepagePartnersNewProps> = ({ data }) => {
  // If data is not provided or enabled is false, don't render anything
  if (!data || data.enabled === false) {
    return null;
  }

  return (
    <section className="box-partenrs">
      <div className="wrapper">
        {data.blockTitle && (
          <div className="block-title">{data.blockTitle}</div>
        )}
        {data.title && <h2>{data.title}</h2>}
        <div className="partenrs-list">
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={0}
            slidesPerView={5}
            breakpoints={{
              0: { slidesPerView: 2 },
              768: { slidesPerView: 3 },
              1024: { slidesPerView: 4 },
              1200: { slidesPerView: 5 },
            }}
            navigation
            pagination={{
              clickable: true,
              type: "fraction",
            }}
            touchRatio={1}
            className="partner-swiper"
          >
            {data.partners?.map((partner, index) => (
              <SwiperSlide key={index}>
                <div className="partenrs-list__item">
                  {partner.file && (
                    <img
                      src={getStrapiMedia(partner.file.url)}
                      alt={partner.title || ""}
                      loading="lazy"
                      decoding="async"
                      width={partner.file.width || undefined}
                      height={partner.file.height || undefined}
                    />
                  )}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default HomepagePartnersNew;
